export default __webpack_public_path__ + "static/media/banner-convenio-mobile.2886483f.svg";